import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Institution', prop: 'member_id', references: 'admin/institutions', referenceProp: 'name' },
  { title: 'Plan', prop: 'membership_plan_id', references: 'admin/membership_plans', referenceProp: 'name' },
  { title: 'Expiry', prop: 'expires_at', format: 'fromNow' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Activated', prop: 'activated_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by institution', prop: 'filters.member_id', type: 'autocomplete', references: 'admin/institutions', referenceProp: 'name', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }],
  filters: {
    member_type: 'institution'
  }
}

const InstitutionMemberships = props => (
  <List
    title='Institution Memberships'
    apiPath='admin/memberships'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default InstitutionMemberships
